export default "__VITE_ASSET__GaN7m5_h__"